import Icon from '../components/Icon.vue'

Icon.register({
  'rupee-sign': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M308 96h-72.9c6 9.8 10.8 20.5 14.3 32h58.7c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-52.8c-7.2 74.5-61.8 125.6-138.3 127.9l150.9 139.3c8 7.4 2.8 20.8-8.1 20.8h-82.6c-2.6 0-6.2-1.4-8.1-3.2l-165.1-152.4c-2.5-2.3-3.9-5.5-3.9-8.8v-53c0-6.6 5.4-12 12-12h84c41.8 0 68.5-22.5 74.8-58.6h-158.8c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h146.3c-12.7-17.3-33.7-27.3-61-27.3h-85.3c-6.6 0-12-5.4-12-12v-44.7c0-6.6 5.4-12 12-12h296c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rupee-sign.js
// module id = 1855
// module chunks = 0